import { Directive, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { IdynamicFormItem } from '../interfaces/IdynamicFormItem';

@Directive({
    selector: '[restrict-input-length]'
})
export class RestrictInputLengthDirective implements OnInit {

    @Input() formItem: IdynamicFormItem;
    @Input() form: FormGroup;

    private _destroyer: Subject<any> = new Subject();


    ngOnInit() {
        if (!this.formItem.restrictValue) {
            return;
        }

        this.form.controls[this.formItem.name].valueChanges.pipe(
            takeUntil(this._destroyer.asObservable()),
            map(rawValue => {
                try {
                    let formItemValue = Number.parseFloat(rawValue);
                    this.restrictMinValue(formItemValue);
                    this.restrictMaxValue(formItemValue);

                } catch (err) {

                }
            })
        ).subscribe();
    }

    restrictMinValue(value: number) {
        if (this.formItem.restrictValue.min !== undefined) {
            if (this.formItem.restrictValue.min) {
                if (this.formItem.min > value) {
                    this.form.controls[this.formItem.name].patchValue(this.formItem.min);
                }
            }
        }
    }

    restrictMaxValue(value: number) {
        if (this.formItem.restrictValue.max !== undefined) {
            if (this.formItem.restrictValue.max) {
                if (this.formItem.max < value) {
                    this.form.controls[this.formItem.name].patchValue(this.formItem.max);
                }
            }
        }
    }

}